import React, { useMemo } from "react"
import TripTypeTabs from "./TripTypeTabs"
import MainSearchForm from "./MainSearchForm"
import DateCard from "./DateCard"
import PassengersCard from "./PassengersCard"
import Button from "../ui/Button"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import {
  selectAviaSearchDates,
  selectSelectedAviaTerminals,
} from "../../../../../app/reducers/book/aviaSearchSlice"
import { collectIds } from "../../utils/processing/search"

const FlightSearchPanel = ({
  defaultArrival,
  departureTerminals,
  arrivalTerminals,
  defaultDeparture,
  handleSearch,
  handleDates,
  children,
  adults,
  infants,
  selectedArrival,
  selectedDeparture,
  fetchTerminals,
  isMainSearchLoading,
  setShouldShowSidebar,
}) => {
  const { t } = useTranslation()

  const { from } = useSelector(selectAviaSearchDates)

  const isSearchDisabled = useMemo(() => {
    const hasDeparture = collectIds(selectedDeparture).length > 0
    const hasArrival = collectIds(selectedArrival).length > 0
    const hasDate = !!from

    return !(hasDeparture && hasArrival) || !hasDate || isMainSearchLoading
  }, [selectedDeparture, selectedArrival, from, isMainSearchLoading])

  return (
    <div className="bg-text-secondary/10 w-full flex flex-col min-h-[160px] gap-4 rounded-b-md rounded-tl-md p-3 relative">
      <TripTypeTabs />
      <div className="flex flex-col xl:flex-row gap-10 xl:gap-5 items-center">
        <MainSearchForm
          arrivalTerminals={arrivalTerminals}
          departureTerminals={departureTerminals}
          defaultArrival={defaultArrival}
          defaultDeparture={defaultDeparture}
          selectedArrival={selectedArrival}
          selectedDeparture={selectedDeparture}
          fetchTerminals={fetchTerminals}
          handleSearch={handleSearch}
          setShouldShowSidebar={setShouldShowSidebar}
          handleDates={handleDates}
        />
        <div className="flex items-center w-full gap-5">
          <DateCard isDeparture={true} onClick={handleDates} />
          <DateCard onClick={handleDates} handleSearch={handleSearch} />
          <PassengersCard count={infants + adults + children} />
        </div>
        <Button
          onClick={() => handleSearch({ isMainSearch: true })}
          className="w-full xl:w-auto"
          size="lg"
          disabled={isSearchDisabled}
        >
          {t("filter.find")}
        </Button>
      </div>
    </div>
  )
}

export default FlightSearchPanel
